import DisplayedFileData from "@src/components/deprecated/FilePopup/DisplayedFileData";
import { FileDocumentData } from "@src/to-be-removed/LocalData/General/FileDocumentData";
import { useLoadedFileURL } from "@src/utils/hooks/useLoadedFileURL";
import { t } from "i18next";
import { LoadingIndicator } from "../LoadingIndicator/LoadingIndicator";
import TypographyText from "../TypographyText/TypographyText";
import styles from "./FilePreview.module.css";
import { PreviewNotAvailable } from "./PreviewNotAvailable";

interface FilePreviewProps {
  file: DisplayedFileData;
}

export const FilePreview = ({ file }: FilePreviewProps) => {
  const fileType = file.previewPath?.split(".").pop() || file.type;

  const externalFileInfo =
    file.externalFileInformation?.propertyID && file.propertyID ? { propertyID: file.propertyID, fileID: file._file.id } : undefined;

  const { fileURL: loadedFileURL, $file } = useLoadedFileURL(file.previewPath || file.path, externalFileInfo);
  const fileURL = file.externalURL || loadedFileURL || file.id;

  if ($file.isLoading) return <LoadingIndicator centerHorizontally marginTop={32} marginBottom={32} />;

  if ($file.isFetched && !fileURL)
    return (
      <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <TypographyText>{t("error.noPreviewAvailable")}</TypographyText>
      </div>
    );

  if (FileDocumentData.SUPPORTED_IMAGE_TYPES.includes(fileType)) return <img className={styles.img} src={fileURL} alt={`${file.name}`} />;

  if (fileType === "pdf")
    return (
      <iframe title={file.name} src={fileURL} height="100%" width="100%">
        <PreviewNotAvailable file={file} />
      </iframe>
    );

  if (FileDocumentData.SUPPORTED_AUDIO_TYPES.includes(fileType)) return <audio className={styles.audioPlayer} controls={true} src={fileURL} />;

  if (FileDocumentData.SUPPORTED_VIDEO_TYPES.includes(fileType)) return <video className={styles.videoPlayer} controls={true} src={fileURL} />;

  return <PreviewNotAvailable file={file} />;
};
